import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  AdminService,
  SwalService,
  UltiService,
} from '__services';
import { RegulatoryDetailComponent } from '../regulatory-detail/regulatory-detail.component';
import { LicenceRate } from '@core/configs/licence';

@Component({
  selector: 'app-shared-profile-company',
  templateUrl: './profile-company.component.html',
  styleUrls: ['./profile-company.component.scss'],
})
export class ProfileCompanyComponent implements OnInit {
  @Input() showButton = false;
  @Input() identifier = null;
  @Input() close = true;
  detail;
  regulatory;
  licenceDetail;

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
    readonly ultiService: UltiService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.data?.identifier) {
      this.identifier = this.data.identifier;
    }
    if (!this.identifier) {
      const userProfile = JSON.parse(localStorage.getItem('userProfile'));
      this.identifier = userProfile.company.identifier;
    }
    if (this.identifier) {
      this.getCompanyDetails();
    }
  }

  getCompanyDetails(): void {
    this.adminService.getCompanyByIdentifier(this.identifier).subscribe(
      (res) => {
        this.detail = res;
        this.regulatory = this.detail.regulatory;
        this.detail.locations = [];
        this.detail.personas_joined = this.detail.personas
          .map((el) => {
            if (el.locations && el.locations.length > 0) {
              this.detail.locations = [
                ...this.detail.locations,
                ...el.locations.map((location) => location),
              ];
            }
            return el.title;
          })
          .join(', ');
        this.analyseLicence(res.licences[0]);
      },
      (error) => {
        let mes = error.message ? error.message : error;
        SwalService.error(mes);
      }
    );
  }

  analyseLicence(licenceData) {
    if (!licenceData) return;
    const { licence_rate, monthly_rate, yearly_rate, start_date, end_date } =
      licenceData;
    const startDate = this.ultiService.formatDate(start_date, 'DD-MMM-YYYY');
    const endDate = this.ultiService.formatDate(end_date, 'DD-MMM-YYYY');
    let licencePrice = monthly_rate;
    if (licence_rate === LicenceRate.YEARLY) {
      licencePrice = yearly_rate;
    }
    this.licenceDetail = {
      ...licenceData,
      durationTime: `${startDate} - ${endDate}`,
      ...this.calculateUsers(licenceData),
      referred_companies: this.detail?.referred_companies || [],
      licencePrice,
    };
  }

  calculateUsers(licenceInfo) {
    const usersPercent: any = {};
    const { users_summary } = this.detail;
    const { white_actived, blue_actived } = users_summary;
    const { white_collar_users, blue_collar_users } = licenceInfo;
    usersPercent.whitePercent = (
      ((white_actived * 1) / white_collar_users) *
      1 *
      100
    ).toFixed(1);
    usersPercent.bluePercent = (
      ((blue_actived * 1) / blue_collar_users) *
      1 *
      100
    ).toFixed(1);
    return usersPercent;
  }

  // calculatePartiesUsers(licenceInfo) {
  //   if(!this.detail?.referred_companies?.length) return [];
  //   const {
  //     company_referred_blue_collar_users,
  //     company_referred_white_collar_users,
  //   } = licenceInfo;
  //   const partiesPercent = this.detail.referred_companies.map((party) => {
  //     return {
  //       ...party,
  //       whitePercent: (
  //         (party.white_actived / company_referred_white_collar_users) *
  //         100
  //       ).toFixed(1),
  //       bluePercent: (
  //         (party.blue_total / company_referred_blue_collar_users) *
  //         100
  //       ).toFixed(1),
  //     };
  //   });
  //   return partiesPercent;
  // }

  openDetailRegulatory() {
    const { status, uen, tradeweb_id } = this.regulatory;
    this.dialog.open(RegulatoryDetailComponent, {
      panelClass: 'customise-dialog',
      data: { status, uen, tradeweb_id },
    });
  }

  changeRegulatoryStatus() {
    let regulatory_status = (this.detail.regulatory.regulatory_status =
      !this.detail.regulatory.regulatory_status);
    this.adminService.updateCompanyInfo({ regulatory_status }).subscribe(
      (res) => {},
      (error) => {
        let mes = error.message ? error.message : error;
        SwalService.error(mes);
      }
    );
  }
}
